import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import useCheckout from '@app/components/pages/checkout/shopping-cart/ShoppingCartPage/hooks/useCheckout.js';
import { AlloyButton } from 'cat-ecommerce-alloy';
import styles from './proceedToCheckoutButton.module.scss';

const ProceedToCheckoutButton = ({ className }) => {
  const [t] = useTranslation();
  const { checkoutPage, isCheckoutButtonDisabled } = useCheckout();

  return (
    <AlloyButton
      buttonType="primary"
      onClick={checkoutPage}
      className={`${styles['proceed-checkout__btn']} ${
        className ? className : ''
      }`}
      disabled={isCheckoutButtonDisabled}
      size="dynamic"
    >
      {t('PROCEED_TO_CHECKOUT')}
    </AlloyButton>
  );
};

ProceedToCheckoutButton.propTypes = {
  className: PropTypes.string
};

export default ProceedToCheckoutButton;
